import React from "react";
import styled from "styled-components";
import { Text4, Text6 } from "@churchofjesuschrist/eden-text";
import { spacing4, spacing16, spacing24 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  componentId: "sc-169bs0j-0"
})(["width:0;min-width:100%;padding-block-start:", ";padding-block-end:", ";"], spacing16, spacing24);
const CaptionText = styled.div.withConfig({
  componentId: "sc-169bs0j-1"
})(["padding-block-end:", ";"], spacing16);
const Attribution = styled.div.withConfig({
  componentId: "sc-169bs0j-2"
})(["justify-self:start;"]);
const Tools = styled.div.withConfig({
  componentId: "sc-169bs0j-3"
})(["margin-inline-start:auto;"]);
const ModalTitle = styled.strong.withConfig({
  componentId: "sc-169bs0j-4"
})(["padding-inline-end:", ";"], spacing4);
const FlexWrapper = styled.div.withConfig({
  componentId: "sc-169bs0j-5"
})(["display:flex;width:100%;align-items:start;"]);

/**
 * Caption for the media item.
 * @param {object} props - The component props
 * @param {string} [props.title] - Media Title
 * @param {React.ReactNode} [props.caption] - Media Caption
 * @param {React.ReactNode} [props.attribution] - Media Attribution
 * @param {React.ReactNode} [props.tools] - Media-related tools (e.g., share and download buttons)
 * @param {string} [props.id] - Unique id for caption text
 * @returns {React.ReactNode} - The Grid component.
 */
const Caption = ({
  title,
  caption,
  attribution,
  tools,
  id
}) => /*#__PURE__*/_jsxs(Container, {
  children: [caption && /*#__PURE__*/_jsx(CaptionText, {
    children: /*#__PURE__*/_jsxs(Text4, {
      id: id,
      children: [title && /*#__PURE__*/_jsx(ModalTitle, {
        children: title
      }), caption]
    })
  }), attribution || tools ? /*#__PURE__*/_jsxs(FlexWrapper, {
    children: [/*#__PURE__*/_jsx(Attribution, {
      children: /*#__PURE__*/_jsx(Text6, {
        children: attribution
      })
    }), /*#__PURE__*/_jsx(Tools, {
      children: tools
    })]
  }) : null]
});
Caption.displayName = "Caption";
export default Caption;